import axios from "axios";

export const state = {
  cached: "",
};

export const getters = {};

export const mutations = {};

export const actions = {
  getAccountBalance({ commit, state, rootState }, { zetrixAccount }) {
    if (zetrixAccount && zetrixAccount.length > 0) {
      return axios
        .get(`/ztx/acc/query?address=${zetrixAccount}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            // commit("SET_BALANCE", response.data.object);
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async getZtp20Balance(
    { commit, state, rootState },
    { contractAddress, address }
  ) {
    return axios
      .post(`/ztx/erc20/balance-of`, {
        contractAddress,
        address,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data.object;
        }
        return null;
      })
      .catch(function () {
        return null;
      });
  },
};
